import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyOwlMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#fff7e6" />
      <circle cx={397} cy={420} r={120} fill="#6b4f2f" />
      <circle cx={347} cy={380} r={30} fill="#fff" />
      <circle cx={447} cy={380} r={30} fill="#fff" />
      <g className="mode-copy" transform="translate(48,840)" fill="#221"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyOwlMode;
